import type { BaseObj } from '@/objects/BaseObj';
import { watchDebounced } from '@vueuse/core';
import { computed, ref, type Ref } from 'vue';

// TODO: If we also can get the IAlertMessages inside here we can do all the return for the DetailViewExpose here and add it to the views
export const useBaseObjectStatus = <T extends BaseObj>(baseobj: Ref<T | null>, titlegetter?: () => string | null | undefined) => {
    let originalValue: string | null = null;

    /**
     * If the object has changed from the original value
     * @type {Ref<boolean>}
     */
    const Changed = ref<boolean>(false);

    /**
     * The title of the object
     */
    const title = ref<string>('');

    /**
     * The value of the object
     */
    const value = baseobj;

    /**
     * We watch the object for changes
     */
    watchDebounced(
        baseobj,
        (newValue) => {
            // If the new value is null we dont want to do anything, it means the object is not loaded
            if (newValue === null) return;

            // If the original value is null we set it to the new value so we have a reference to compare against
            if (originalValue === null) {
                originalValue = JSON.stringify(newValue);
            }

            Changed.value = originalValue !== JSON.stringify(newValue);
            title.value = titlegetter ? titlegetter() || '' : '';
        },
        { debounce: 500, deep: true, immediate: true },
    );

    return {
        Changed,
        Title: computed(() => title.value),
        Value: computed<T | null>(() => value.value),
    };
};
